// Vendors
import React from 'react';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { StyledComponentsProvider, reloadedThemes } from '@gruposantander/opbpay-ui-components';
// Styles
import ThemeProviderStyled from './theme.provider.styled';
import { ThemeProviderType } from './types/theme.provider.type';

const ThemeProvider = ({
  children,
  theme,
}: ThemeProviderType): React.ReactElement<ThemeProviderType> => (
  <StyledProvider {...{ theme }}>
    <StyledComponentsProvider theme={reloadedThemes.cobranded_light_regular as any}>
      {children}
    </StyledComponentsProvider>
    <ThemeProviderStyled />
  </StyledProvider>
);

export default ThemeProvider;
